<template>
  <div class="product-manager">
    <custom-table
      :tableHeader="tableHeader"
      :page="api.page"
      :pagination="false"
      @next="handleNextPage()"
      @prev="handlePrevPage()"
    >
      <template v-if="items.length > 0 && !loaders.page">
        <fragment v-for="(item, i) in items" :key="i">
          <tr v-if="showLinkName(item, i)">
            <td
              :colspan="tableHeader.length"
              class="product-manager--link-label"
            >
              <div class="vertical-link">
                <span></span>
              </div>
              <div class="product-manager--link-name">
                <img
                  class="icon-link"
                  src="~@/assets/media/icons/link-icon.svg"
                  alt="link icon"
                />
                <p>
                  {{ item.ProductLink.ProductCollection.name }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="product-manager--item-name">
              <div v-if="item.ProductLink" class="vertical-link">
                <span></span>
                <span
                  class="last-border"
                  v-if="
                    items[i + 1] &&
                      items[i + 1].ProductLink &&
                      items[i + 1].ProductLink.productCollectionId ===
                        item.ProductLink.productCollectionId
                  "
                ></span>
              </div>
              <div :class="[{ 'offset-left': item.ProductLink }]">
                {{ item ? item.name : "" }}
              </div>
            </td>
            <td>{{ item && item.Category ? item.Category.name : "" }}</td>
            <td>{{ item && item.Location ? item.Location.name : "" }}</td>
            <td>
              <ul
                class="d-flex flex-column"
                v-if="item.Terms && item.Terms.length"
              >
                <li v-for="term in item.Terms" :key="term.id">
                  {{ term.name }}
                </li>
              </ul>
            </td>
            <td>
              <ul class="d-flex flex-column" v-if="item.Packages.length">
                <li v-for="term in item.Terms" :key="term.id">
                  <template v-for="pack in item.Packages">
                    <span v-if="term.id == pack.termId" :key="pack.id">
                      P {{ pack.price }}
                    </span>
                  </template>
                </li>
              </ul>
            </td>
            <td>{{ item.Schedule ? item.Schedule.name : "" }}</td>
            <td>
              <div class="d-flex align-items-center">
                <div
                  class="switch mr-2"
                  :class="{ active: item.status < 2 ? false : true }"
                  @click="handleClickUpdateStatus($event, item)"
                >
                  <div class="indicator"></div>
                </div>
                <span>{{ item.status > 1 ? "Active" : "Inactive" }}</span>
              </div>
            </td>
            <td class="table__content-action position-relative">
              <action-button
                label=""
                style="margin-right: 15px; margin-top: 0;"
                @customEvent="handleClickEdit(item)"
              >
                <img
                  src="~@/assets/media/icons/create-light.svg"
                  alt="edit icon"
                />
              </action-button>
              <action-button
                label=""
                :disabled="!!(item.ProductLink && item.ProductLink.id)"
                :class="[
                  'btn--remove position-relative',
                  {
                    'disabled--btn': !!(item.ProductLink && item.ProductLink.id)
                  }
                ]"
                style="margin-right: 0; margin-top: 0;"
                @customEvent="handleClickDelete(item)"
              >
                <div
                  class="tooltipText"
                  v-if="!!(item.ProductLink && item.ProductLink.id)"
                >
                  <p>To delete product, please remove product link</p>
                </div>
                <FetchingOverlay v-if="loaders.deleteButton === item.id" />
                <span v-else>
                  &mdash;
                </span>
              </action-button>
            </td>
          </tr>
        </fragment>
      </template>
      <tr v-else-if="loaders.page">
        <td colspan="5">
          <Spinner :theme="primary" />
        </td>
      </tr>
      <tr v-else>
        <td colspan="5">
          No Products found...
        </td>
      </tr>
    </custom-table>
  </div>
</template>

<script>
import FetchingOverlay from "@/components/FetchingOverlay";
import ActionButton from "@/components/ActionButton";
import Spinner from "@/components/Spinner";
import CustomTable from "../CustomTable";
import { packages } from "../../helpers/table-headers";
import { socketSender } from "@/helpers/socket";
import { mapActions, mapGetters } from "vuex";
import axios from "@/helpers/axios";

export default {
  components: {
    ActionButton,
    CustomTable,
    Spinner,
    FetchingOverlay
  },
  data: () => ({
    tableHeader: [],
    api: {
      page: 1,
      size: 500,
      action: "orderBy=productLinkSort,id:DESC"
    },
    loaders: {
      page: true,
      deleteButton: -1
    },
    productCollectionId: null
  }),
  created() {
    this.init();
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    user() {
      return this.$store.getters.getFullUser;
    },
    items: {
      get() {
        return this.GET_COLLECTION();
      }
    }
  },
  methods: {
    ...mapActions({
      FETCH_COLLECTION_PER_PAGE: "FETCH_COLLECTION_PER_PAGE"
    }),
    ...mapGetters({
      GET_COLLECTION: "GET_COLLECTION"
    }),
    init() {
      this.tableHeader = packages;
      this.handleReloadPage();
    },
    showLinkName(product, index) {
      if (!product.ProductLink || !product.ProductLink.ProductCollection)
        return false;

      if (index === 0) return true;

      return (
        this.items[index - 1].ProductLink.productCollectionId !==
        product.ProductLink.ProductCollection.id
      );
    },
    handleClickEdit(item) {
      const { page, size, action } = this.api;
      this.$emit("edit", {
        singleRecord: item,
        link: this.pagelink(page, size, action)
      });
    },
    async handleClickDelete(item) {
      if (item.ProductLink && item.ProductLink.id) return;
      this.$swal({
        title: "Are you sure to remove this data",
        type: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true
      }).then(async result => {
        if (result.value) {
          this.loaders.deleteButton = item.id;
          await axios.delete(`/products/${item.id}`).then(async result => {
            this.loaders.deleteButton = -1;
            if (result.data.response != "success") {
              this.$swal({
                title: result.data.response,
                type: "error"
              });
            } else {
              socketSender(
                "updateLog",
                `${this.user} removed the package named ${item.name}`
              );
              await this.handleReloadPage();
            }
          });
        }
      });
    },
    async handleReloadPage() {
      const { page, size, action } = this.api;
      await this.FETCH_COLLECTION_PER_PAGE(this.pagelink(page, size, action));
      this.loaders.page = false;
    },
    handleNextPage() {
      this.api.page += 1;
      this.loaders.page = true;
      this.handleReloadPage();
    },
    handlePrevPage() {
      this.api.page -= 1;
      this.loaders.page = true;
      this.handleReloadPage();
    },
    pagelink(page, size = 500, action = "orderBy=productLinkSort,id:DESC") {
      return `/products?page[number]=${page}&page[size]=${size}&${action}`;
    },
    async handleClickUpdateStatus($event, item) {
      let data = {
        status: item.status < 2 ? 2 : 1
      };
      switch (item.status) {
        case 2:
          $event.target.classList.remove("active");
          break;
        case 1:
          $event.target.classList.add("active");
          break;
      }
      await axios.patch(`/products/${item.id}`, data).then(() => {
        this.$toastr.success("Product update success.");
      });
      await this.handleReloadPage();
    }
  }
};
</script>
<style lang="scss">
.product-manager {
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      display: block;
      padding: 3px 0;
    }
  }

  table {
    thead th:first-child {
      width: 176px;
    }
  }

  &--item-name {
    position: relative;

    p {
      margin-bottom: 0;
    }

    .offset-left {
      padding-left: 22px;
    }
  }

  .vertical-link {
    position: absolute;
    left: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 14px;
    span {
      border-left: dashed 2px #00b372;
      border-bottom: dashed 2px #00b372;
      width: 100%;
      height: 10px;

      &.last-border {
        border-bottom: none;
        height: 100%;
      }
    }
  }

  &--link-label {
    position: relative;

    .vertical-link {
      display: flex;
      justify-content: end;

      span {
        height: 50%;
        border-bottom: none;
      }
    }
  }

  &--link-name {
    display: flex;
    flex-direction: row;

    p {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0px;
      color: #232323;
      margin-left: 8px;
      margin-bottom: 0;
    }

    .icon-link {
      width: 16px;
    }
  }
}

.btn--remove {
  background-color: #fa533d !important;
}

.disabled--btn {
  background: #b7b7b7 !important;
  opacity: 1 !important;

  .tooltipText {
    z-index: 10;
    opacity: 0;
    content: "";
    visibility: hidden;
    transition: 300ms;
    position: absolute;
    background: #4c4c4c;
    width: 180px;
    height: auto;
    border-radius: 5px;
    top: 40px;
    right: -78px;
    padding: 4px 12px;
    p {
      white-space: normal;
      text-align: start;
      font-size: 12px;
      margin-bottom: 0;
    }
  }

  &:after {
    opacity: 0;
    content: "";
    visibility: hidden;
    transition: 300ms;
    position: absolute;
    border-style: solid;
    border-color: transparent transparent #4c4c4c transparent;
    border-width: 8px;
    top: 25px;
    left: 4px;
  }

  &:hover {
    .tooltipText,
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
